import React, { useEffect, Component, useState, useRef } from "react";
import Header from "../../containers/Header";
import Footer from "../../containers/Footer";
import { useHistory,useParams, Link } from "react-router-dom";
import { ApiService } from "../../containers/Services/apiservice";
import { Watch } from "react-loader-spinner";
let apiServices = new ApiService();
const Investment = () => {
  let history = useHistory();
  const didMountRef = useRef(true);
  const [MutualFundEquityData, setMutualFundEquityData] = useState([]);
  const [MutualFundDebtData, setMutualFundDebtData] = useState([]);
  const [spinnerLoading, setSpinnerLoading] = useState(false);
  const [Message, setMessage] = useState('');
  const { id } = useParams();
  useEffect(() => {
    if (didMountRef.current) {
      mutualfunddataamultifiler();
    }
    didMountRef.current = false;
  });
  const mutualfunddataamultifiler = () => {
    setSpinnerLoading(true);
    const dataString = {
      type: "investment",
      gs_id:id
    };
    apiServices.getmutualInvestmentData(dataString).then((res) => {
      if (res.data.status == "success") {
        setMutualFundEquityData(res.data.equity);
        setMutualFundDebtData(res.data.debt);
        setSpinnerLoading(false);
        setMessage(res.data.message)
      }
      else if(res.data.status == "error" && res.data.message == "Session expired"){
        localStorage.removeItem('AUTH_TOKEN');
        // alert(res.data.message)
        setSpinnerLoading(false)
        history.push("/login")           
    }
    else{
      alert(res.data.message)
      setSpinnerLoading(false)
      return false
    }
    });
  };
  return (
    <div>
        <div className={spinnerLoading == true ? 'parentDisable' : ''} width="100%">
        <div className='overlay-box'>     
            <Watch
                color="#ffffff"
                visible={spinnerLoading}
                />
            </div>
                </div>
      <Header />
      <section className="section-small">
        <div className="container-fluid">
          <div className="row">
            <p>{Message}</p>
            <div className="col-lg-6">
              <h3>Equity</h3>
            <div className="fundlist">
                <ul>
                  {MutualFundEquityData.length > 0
                    ? MutualFundEquityData.map((key) => (
                        <Link to={`/mfdetail/${key.mf_id}`}>
                          <li>
                            <div>
                              <h6 className="mg-b-5">{key.plan_name}</h6>
                              <p className="mg-b-0 tx-12">{key.scheme_code}</p>
                            </div>
                          </li>
                        </Link>
                      ))
                    : ""}
                </ul>
              </div>
            </div>
            <div className="col-lg-6">
              <h3>Debt</h3>
              <div className="fundlist">
                <ul>
                  {MutualFundDebtData.length > 0
                    ? MutualFundDebtData.map((key) => (
                        <Link to={`/mfdetail/${key.mf_id}`}>
                          <li>
                            <div>
                              <h6 className="mg-b-5">{key.plan_name}</h6>
                              <p className="mg-b-0 tx-12">{key.scheme_code}</p>
                            </div>
                          </li>
                        </Link>
                      ))
                    : ""}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Investment;
